module.exports = __webpack_public_path__ + "img/more.6f298a01.svg";